export default {
  getUnverified: (state) => state.unverified.list.items,
  getUnverifiedPaginationData: (state) => state.unverified.list.meta,
  getUnverifiedIsFetching: (state) => state.unverified.list.isFetching,
};
